/** Keeps map links on HTTP(S), including relative server URLs, and rejects script/data schemes. */
export function mapLink(value) {
  if (!value) {
    return undefined;
  }
  try {
    const url = new URL(value, window.location.href);
    return ["http:", "https:"].includes(url.protocol) ? value : undefined;
  } catch {
    return undefined;
  }
}
